<template>
  <v-row class="mt-1">
    <v-col>
      <ValidationObserver ref="lotForm" v-slot="{ invalid, validated }">
        <v-expansion-panels multiple>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="info" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="info">
                  <v-icon>
                    info
                  </v-icon>
                  {{ $t('Общая информация') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2 pt-0">
                    <validatable-text-input
                        v-model="lot.lotDescription"
                        :readonly="readonly"
                        rules="required"
                        :label="$t('Предмет договора')" />
                  </v-col>
                  <v-col
                      cols="6"
                      md="6"
                      class="pl-2">
                    <validatable-date-picker
                        v-model="lot.publicationDate"
                        v-test="{ date: 'publicationDate' }"
                        rules="required"
                        dense
                        :label="$t('Дата публикации')" />
                  </v-col>
                  <v-col
                      cols="12"
                      class="pl-2">
                    <validatable-enum-combobox
                        v-model="lot.premiumType"
                        :values-enum="PREMIUM_TYPE_ENUM"
                        rules="required"
                        dense
                        readonly
                        :clearable="!readonly"
                        :label="$t('Способ расчета цены')" />
                  </v-col>
                  <v-col
                      cols="12"
                      class="pl-2">
                    <validatable-text-input
                        v-if="isFixPremium"
                        v-model="lot.currency"
                        rules="required"
                        readonly
                        :label="$t('Валюта Договора')" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
          <v-expansion-panel v-test="{ panel: '' }">
            <ValidationObserver ref="contacts" v-slot="{ failed }">
              <v-expansion-panel-header>
                <div id="contact_mail">
                  <v-icon>
                    contact_mail
                  </v-icon>
                  {{ $t('Контактная информация') }}
                  <v-icon v-if="failed" color="error">
                    warning
                  </v-icon>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-row>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactPerson"
                        v-test="{ input: 'contactPerson' }"
                        prepend-icon="person"
                        rules="required"
                        dense
                        :label="$t('Контактное лицо')" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactPhone"
                        v-test="{ input: 'contactPhone' }"
                        dense
                        :rules="{ required: true,
                                  regex: /^[+]?[\d\s(\-);,]+$/ }"
                        :label="$t('Контактный телефон')"
                        prepend-icon="settings_phone"
                        :type="'tel'" />
                  </v-col>
                  <v-col
                      cols="12"
                      md="6"
                      class="pl-2">
                    <validatable-text-input
                        v-model="lot.contactEmail"
                        v-test="{ input: 'contactEmail' }"
                        dense
                        rules="required|email"
                        :label="$t('Электронный адрес')"
                        prepend-icon="alternate_email" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </ValidationObserver>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-alert
            class="text-center"
            :value="invalid && validated"
            type="error">
          {{ $t('Не все поля заполнены.') }}
        </v-alert>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
  import Vue from 'vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import { DICTIONARY_TYPES, PREMIUM_TYPES } from '@/constants/business'
  import { PREMIUM_TYPE_ENUM } from '@/constants/enums'

  export default {
    components: {
      ValidatableDatePicker,
      ValidatableTextInput,
      ValidatableEnumCombobox
    },
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      saveMethod: {
        type: Function
      },
      lotInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        DICTIONARY_TYPES,
        PREMIUM_TYPE_ENUM,
        lot: {
          creatorId: null,
          lotDescription: null,
          publicationDate: null,
          premiumType: null,
          currency: 'Рубль РФ',
          contactPerson: null,
          contactPhone: null,
          contactEmail: null
        }
      }
    },
    computed: {
      hasChanges () {
        return Object.keys(this.lot).some(key => {
          return this.lot[key] !== this.lotInfo[key]
        })
      },
      isFixPremium () {
        return this.lot.premiumType === PREMIUM_TYPES.FIX
      }
    },
    watch: {
      lotInfo: {
        deep: true,
        immediate: true,
        handler: function (newVal) {
          this.mapFields(newVal)
        }
      }
    },
    beforeDestroy () {

    },
    created () {
    },
    methods: {
      validateAndSave: async function () {
        const result = await this.$refs.lotForm.validate()
        if (!result) {
          throw new Vue.errorsTypes.ValidationError()
        }
        // если изменений нет, то сохранение не нужно
        if (this.readonly || !this.hasChanges) {
          return
        }
        if (this.saveMethod) {
          await this.saveMethod(this.lot)
        }
      },
      mapFields: async function (lot) {
        if (!lot.lotId) {
          return
        }
        for (const key in this.lot) {
          if (this.lot[key] !== lot[key]) {
            this.lot[key] = lot[key]
          }
        }
      }
    }
  }
</script>
